import { Field as BaseField } from "rc-field-form";
import { useTranslation } from "react-i18next";
import Field from "../../../../../../components/Field";
import Switch from "../../../../../../components/Inputs/Switch";
import { Input } from "reactstrap";

/**
 * Short-gap miss-punch. Two punches of the same shift closer together than this are treated as one
 * of them not being a real punch, and the times either side of it are raised as miss-punches for
 * someone to correct. Only applies to punches from a clock - never to times entered by hand.
 */
function MissPunchGap({ disabled }) {
    const { t } = useTranslation();

    return (
        <div className="border-bottom mb-5">
            <div className="mb-4">
                <Field
                    name={["missPunchGap", "status"]}
                    valuePropName="checked"
                >
                    <Switch disabled={disabled}>
                        <h3 className="m-0 p-0">{t("miss-punch-gap")}</h3>
                    </Switch>
                </Field>

                <BaseField shouldUpdate>
                    {({ }, { }, { getFieldValue, getFieldError }) => {
                        const status = getFieldValue(["missPunchGap", "status"]);
                        const [error] = getFieldError(["missPunchGap", "value"]);

                        return status && (
                            <>
                                <div className="d-flex align-items-center mb-2 pl-5">
                                    <p className="mr-2 text-sm mb-0">
                                        {t("miss-punch-gap-when-punches-are-within")}
                                    </p>

                                    <BaseField
                                        name={["missPunchGap", "value"]}
                                        rules={[
                                            {
                                                required: true,
                                                message: t("required-value")
                                            },
                                            {
                                                validator(_, value) {
                                                    if (Number(value) <= 0) {
                                                        return Promise.reject(new Error(t("value-bigger-than-zero")))
                                                    }
                                                    return Promise.resolve()
                                                }
                                            },
                                        ]}
                                    >
                                        <Input
                                            type="number"
                                            size="sm"
                                            className="input-number"
                                            disabled={disabled}
                                            step="1"
                                        />
                                    </BaseField>

                                    <p className="ml-2 text-sm mb-0">
                                        {t("miss-punch-gap-minutes-of-each-other")}
                                    </p>
                                </div>

                                {error && (
                                    <div className="d-block invalid-feedback">
                                        {error}
                                    </div>
                                )}
                            </>
                        );
                    }}
                </BaseField>
            </div>
        </div>
    );
}

export default MissPunchGap;
